import React from 'react';
import { motion } from 'framer-motion';
import { Users, Target, Activity } from 'lucide-react';
import { ClientProgressChart } from './ClientProgressChart';
import { ClientGoalCompletion } from './ClientGoalCompletion';
import { ClientRetentionMetrics } from './ClientRetentionMetrics';

export function ClientProgressMetrics() {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Progress Overview */}
        <div className="lg:col-span-2">
          <ClientProgressChart />
        </div>

        {/* Goal Completion */}
        <div>
          <ClientGoalCompletion />
        </div>
      </div>

      {/* Retention Metrics */}
      <ClientRetentionMetrics />
    </div>
  );
}